import axios from 'axios'
import {BUSCAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarMapaVeiculoAgendamentoViagemPoltrona(agendamentoId, empresaId) {
    const url = `${URL}/mapas-veiculos/agendamento-viagem/${agendamentoId}/empresa/${empresaId}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_MAPA_VEICULO_AGENDAMENTO_VIAGEM,
            payload: response

        })
    );
}
